module.exports = __webpack_public_path__ + "static/media/wpressr.6e8e7f40.svg";